var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "osResHeader txtC padBXM padTop",
        staticStyle: { color: "#2c2c2c" }
      },
      [
        _c("div", { staticClass: "widL info" }, [
          _c("p", [
            _c("img", {
              staticStyle: {
                "max-width": "130.4px",
                "min-width": "81px",
                width: "24.3%"
              },
              attrs: {
                src:
                  "https://www.amway.co.kr/_ui/_noticeImg/logo/logo_artistry_notm_s.png",
                alt: "Artistry(로고)"
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticClass: "tit fntH1 fntM padTS",
              staticStyle: {
                "line-height": "1.2",
                "margin-bottom": "0",
                color: "#2c2c2c",
                "font-weight": "500"
              }
            },
            [_vm._v("아티스트리"), _c("br"), _vm._v(" 메이크업 서비스 예약")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "vis marTX padTS marBML txtC" }, [
            _c("img", {
              attrs: {
                src:
                  "https://www.amway.co.kr/_ui/_noticeImg/2023/03/0323_p_magmoRide_promo/blank.png",
                alt: "아티스트 메이크업 서비스 이미지"
              }
            })
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27a55b60", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27a55b60","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/artistry/makeover/components/header.vue
// module id = null
// module chunks = 